import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import jobsApi from '../../APIs/jobs';
import {
  Button,
  Flex,
  Modal,
  ProgressStep,
  Typography,
} from '../../designComponents';
import { RootState } from '../../store/selectors';
import theme from '../../theme';
import { requestAPI } from '../../utils';
import { getLatestReview, getReviewHistory } from '../../utils/reviews';
import ReviewHistory from '../TechnicianJobs/ReviewAndSend/ReviewHistory';
import PDFReviewByClient from './PDFReviewByClient';
import { ClientReviewAndJobProcessStatusStyled } from './style';
import AddPrinterJob from '../../pages/CreateJobs/CreateNewJobs/AddPrinterJob';
type Props = {
  jobAndProposalId?: string;
};

const jobProcessStep = [
  'INPROGRESS',
  'PDF_UPLOAD',
  'REVIEW',
  'SEND_CLIENT',
  'COMPLETED',
] as const;

const ClientReviewAndJobProcessStatus = ({ jobAndProposalId }: Props) => {
  const [inProgress, setInProgress] = useState<number>(1);
  const [completedStep, setCompletedStep] = useState<number>(1);
  const jobProcess = useSelector((state: RootState) => state.singleJobProcess);
  const jobProcessStatus = useSelector(
    (state: RootState) => state.singleJobProcessStatus
  );

  const reviews = jobProcess?.review || [];
  const clientReviews = jobProcess?.clientReview || [];

  const latestReview = getLatestReview(reviews, true);
  const historyReview = getReviewHistory(reviews, true);
  const latestClientReview = clientReviews.find(
    (cr) => cr.adminReview === latestReview?._id
  );

  const getJobProcess = async (jobNProposalId: string) => {
    try {
      await requestAPI(jobsApi.getJobProcessByJobProposal(jobNProposalId));
    } catch (error) {
      console.error(error);
    }
  };
  const getJobProcessStatus = async (jobNProposalId: string) => {
    try {
      const response = await requestAPI(
        jobsApi.getJobProcessStatusByJobProposal(jobNProposalId)
      );

      if (response && response?.isSendToClient?.length > 0) {
        getJobProcess(jobNProposalId);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (jobAndProposalId) {
      getJobProcessStatus(jobAndProposalId);
    }
  }, [jobAndProposalId]);
  const [openPrinterModal, setOpenPrinterModal] = useState(false);

  useEffect(() => {
    if (jobProcessStatus?._id) {
      const completedStepNumber = jobProcessStep.findIndex(
        (x) => x === jobProcessStatus.status
      );
      setInProgress(completedStepNumber + 1);
      const isProcessCompleted = jobProcessStatus.status === 'COMPLETED';
      setCompletedStep(
        isProcessCompleted ? completedStepNumber + 1 : completedStepNumber
      );
    }
  }, [jobProcessStatus]);

  if (!jobAndProposalId) {
    return null;
  }
  const isSentToClient =
    latestReview && jobProcess?._id
      ? Array.isArray(jobProcess?.isSendToClient) &&
        jobProcess?.isSendToClient?.includes(latestReview._id) &&
        latestClientReview?.isActive
      : false;
  return (
    <ClientReviewAndJobProcessStatusStyled>
      <div style={{ marginBottom: '30px' }}>
        <ProgressStep
          completedStep={completedStep}
          inProgressStep={inProgress}
          steps={[
            {
              label: 'In Progress',
              stepNumber: 1,
            },
            {
              label: 'PDF Upload',
              stepNumber: 2,
            },
            {
              label: 'Review by Escape Plan',
              stepNumber: 3,
            },
            {
              label: 'Sent to Client',
              stepNumber: 4,
            },
            {
              label: 'Completed',
              stepNumber: 5,
            },
          ]}
        />
      </div>
      <div>
        {jobProcessStatus?.status === 'SEND_CLIENT' && !isSentToClient && (
          <Flex
            justifyContent="center"
            padding="5px 10px"
            style={{
              background: theme.colors.TECHNICIAN.faded,
              borderRadius: '12px',
            }}
          >
            <Typography
              variant="title"
              style={{ color: theme.colors.TECHNICIAN.strong }}
            >
              Note: Job is almost completed. Let's wait until technician sent
              the completed job to you.
            </Typography>
          </Flex>
        )}
      </div>

      {isSentToClient && jobProcess.status === 'SEND_CLIENT' ? (
        <PDFReviewByClient
          jobProcess={jobProcess}
          refetchJobProcess={() => getJobProcessStatus(jobAndProposalId)}
        />
      ) : null}

      {Array.isArray(jobProcessStatus?.isSendToClient) &&
        jobProcessStatus?.isSendToClient?.length > 0 && (
          <ReviewHistory
            historyReview={historyReview}
            clientReview={clientReviews}
            isClient
          />
        )}
      {jobProcess.status === 'COMPLETED' && (
        <Button
          onClick={() => {
            setOpenPrinterModal(true);
          }}
        >
          Send to Printer
        </Button>
      )}
      <Modal
        onClose={() => {
          setOpenPrinterModal(false);
        }}
        open={openPrinterModal}
        style={{}}
      >
        <AddPrinterJob
          onClose={() => {
            setOpenPrinterModal(false);
          }}
          pdfs={jobProcess?.review[jobProcess.review.length - 1]?.pdf}
          jobProcessId={jobProcess._id}
          jobId={jobProcess?.job?._id ?? ''}
        ></AddPrinterJob>
      </Modal>
    </ClientReviewAndJobProcessStatusStyled>
  );
};

export default ClientReviewAndJobProcessStatus;
